import { render, staticRenderFns } from "./PAF.vue?vue&type=template&id=5997234e&scoped=true"
import script from "./PAF.vue?vue&type=script&lang=js"
export * from "./PAF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997234e",
  null
  
)

export default component.exports